import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  layout?: "card" | "row";
}

export default function NewsCard({ item, layout = "card" }: NewsCardProps) {
  if (layout === "row") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-full sm:w-48 shrink-0 aspect-[3/2] rounded-md overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} - 希岛爱理资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex-1 flex flex-col">
          <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
            <i className="ri-calendar-line" />
            <time>{item.date}</time>
          </div>
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors line-clamp-2">
            {item.title}
          </h3>
          <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed flex-1">
            {item.summary}
          </p>
          <span className="mt-3 text-sm text-accent-600 font-medium inline-flex items-center gap-1">
            阅读全文
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="w-full aspect-[3/2] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 希岛爱理资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
          <i className="ri-calendar-line" />
          <time>{item.date}</time>
        </div>
        <h3 className="font-heading font-semibold text-base text-foreground-950 group-hover:text-primary-700 transition-colors line-clamp-2">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-3 leading-relaxed">{item.summary}</p>
      </div>
    </Link>
  );
}